
import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import Logo1 from "../images/logo1.png";
import Logo2 from "../images/logo2.png";

const Footer = ({ handleThemeChange }) => {

  const [theme, setTheme] = useState('')

  useEffect(() => {
    const usedTheme = localStorage.getItem("theme");
    usedTheme === "device" ? setTheme("device") : usedTheme === "light" ? setTheme("light") : setTheme("dark")
  })

  return (
    <div className="footer">
      <div className="p-5">
        <div className="px-3">
          {/* Your Logo */}
          <div className="position-absolute translate-middle">
            {theme === "dark" ? <img src={Logo2} alt="Your Logo" /> : <img src={Logo1} alt="Your Logo" />}
          </div>
          <div className="text-center pt-5">
            {/* Social Icons */}
            <span className="bi bi-twitter-x me-3"></span>
            <span className="bi bi-github me-3"></span>
            <span className="bi bi-facebook"></span>
          </div>

          <div className="text-center pt-3">
            {/* Theme Switcher */}
            <div className="switch">
              <ButtonGroup variant="" className="ButtonGroup">
                <Button className={`bi bi-moon ${theme === "dark" ? "active" : ""}`} onClick={() => handleThemeChange("dark")}></Button>
                <Button className={`bi bi-sun ${theme === "light" ? "active" : ""}`} onClick={() => handleThemeChange("light")}></Button>
                <Button className={`bi ${theme === "device" ? "active" : ""}`} onClick={() => handleThemeChange("device")}>
                  <span className="material-symbols-outlined">laptop_mac</span>
                </Button>
              </ButtonGroup>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;

